<ng-container *ngIf="this.local_data?.reportData && showPdf" class="pdf-container">
    <button class="close-btn" (click)="closeDialog()">✖</button>
    <ngx-extended-pdf-viewer   [zoom]="'page-width'" [base64Src]="this.local_data?.reportData"  *ngIf="showPdf" (after-load-complete)="onPdfLoaded()">
        </ngx-extended-pdf-viewer>
        <!-- <ngx-extended-pdf-viewer [src]="pdfSrc" height="80vh"></ngx-extended-pdf-viewer> -->
</ng-container> 